// these configs decide what values can be showed in the respective blocks from the values object
export const Details = ["firstname", "lastname", "email", "phonenumber", "collectorsaccountno"];

export const DeliveryAddressInternational = [
  "addresslineone",
  "addresslinetwo",
  "addresslinethree",
  "addresslinefour",
  "eircodeoptional",
  "country"
];

export const DeliveryAddressNational = [
  "nationaladdresslineone",
  "nationaladdresslinetwo",
  "nationaladdresslinethree",
  "nationaladdresslinefour",
  "nationaleircodeoptional",
  "nationalcounty",
  "autoaddress1",
  "autoaddress2",
  "autoaddress3",
  "autoaddress4",
  "autoaddress5"
];

export const NewDetails = ["newfirstname", "newlastname", "newemail", "newphonenumber", "newcollectorsaccountno"];

export const NewAddressInternational = [
  "newaddresslineone",
  "newaddresslinetwo",
  "newaddresslinethree",
  "newaddresslinefour",
  "neweircodeoptional",
  "newcountry"
];

export const NewAddressNational = [
  "newnationaladdresslineone",
  "newnationaladdresslinetwo",
  "newnationaladdresslinethree",
  "newnationaladdresslinefour",
  "newnationaleircodeoptional",
  "newnationalcounty",
  "autonewaddress1",
  "autonewaddress2",
  "autonewaddress3",
  "autonewaddress4",
  "autonewaddress5"
];